import { GA_PUSH_DATA_API, NEW_PLANPAGE_URL } from 'constants/index';
import { getPrcCookieValue } from 'utils/primeUtil';
import { getCookie } from 'utils/cookies';
import makeRequest from 'utils/makeRequest';

export const redirectToPlanPage = (
  planPageUrl = NEW_PLANPAGE_URL,
  isToipArtcileShow = false,
) => {
  let url = planPageUrl;
  const currentUrl = window.location.href;
  const currUrlObj = new URL(currentUrl);
  const utmSource = currUrlObj.searchParams.get('utm_source') || null;
  const utmMedium = currUrlObj.searchParams.get('utm_medium') || null;
  const utmCampaign = currUrlObj.searchParams.get('utm_campaign') || null;

  if ((utmSource || utmMedium || utmCampaign) && isToipArtcileShow) {
    url = `${url}?isPrimeArticle=true&utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}`;
  } else if (isToipArtcileShow) {
    url = `${url}?isPrimeArticle=true`;
  } else if (utmSource || utmMedium || utmCampaign) {
    url = `${url}?utm_source=${utmSource}&utm_medium=${utmMedium}&utm_campaign=${utmCampaign}`;
  }

  return url;
};

export const newPlanpageMetaData = (data = {}, userObj = {}) => {
  const {
    dealCode,
    planGroup,
    planGroupAutoSelected,
    planCodeAutoSelected,
    nudgePlanGroupAutoSelected,
    nudgePlanCodeAutoSelected,
    otherPlanCodes,
    ctaLink,
  } =
    data?.unifiedNodes || {};
  return {
    url: ctaLink || '',
    dealCode: dealCode || '',
    planCode: planGroup || '',
    planGroupAutoSelected: planGroupAutoSelected || '',
    planCodeAutoSelected: planCodeAutoSelected || '',
    nudgePlanGroupAutoSelected: nudgePlanGroupAutoSelected || '',
    nudgePlanCodeAutoSelected: nudgePlanCodeAutoSelected || '',
    otherPlanCodes: otherPlanCodes || '',
    platform: data?.platform || 'TOI',
    productCode: data?.productCode || 'TOIPLUS',
    ticketId: userObj.tempTicket,
    acqSubSource: data?.acqSubSource,
    featureCode: data?.featureCode || '',
  };
};

export const doNotAppendUrlIfEmpty = (passedUrl, arrayKeys, arrayValues) => {
  let url = passedUrl;
  if (!(url.indexOf('?') > -1)) {
    url = `${url || NEW_PLANPAGE_URL}`;
  }

  // for (let i = 0; i < arrayKeys.length; i += 1) {
  let i = 0;
  // let j = 0;
  while (i < arrayKeys.length) {
    if (arrayValues[i]) {
      if (!(url.indexOf('?') > -1)) {
        url += arrayValues[i] ? `?${arrayKeys[i]}=${arrayValues[i]}` : '';
      } else {
        url += arrayValues[i] ? `&${arrayKeys[i]}=${arrayValues[i]}` : '';
      }
      // j += 1;
    }
    i += 1;
  }
  return url;
};

export const redirectToNewPlanpage = ({
  url = NEW_PLANPAGE_URL,
  dealCode = '',
  planCode = '',
  planGroupAutoSelected = '',
  planCodeAutoSelected = '',
  nudgePlanGroupAutoSelected = '',
  nudgePlanCodeAutoSelected = '',
  otherPlanCodes = '',
  platform = 'TOI',
  productCode = 'TOIPLUS',
  ticketId = '',
  acqSubSource = window.location.href.indexOf('epaper.indiatimes.com') > -1
    ? 'EpaperWeb'
    : 'TOIWeb',
  featureCode = '',
}) => {
  const currentUrl = window.location.href;
  const currUrlObj = new URL(currentUrl);
  const utmSource = currUrlObj.searchParams.get('utm_source') || '';
  const utmMedium = currUrlObj.searchParams.get('utm_medium') || '';
  const utmCampaign = currUrlObj.searchParams.get('utm_campaign') || '';
  const grxId = getCookie('_grx');
  const arrayKeys = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'product',
    'productCode',
    'dealCode',
    'groupCodes',
    'plt',
    'defaultGroupName',
    'defaultPlanCode',
    'nudgePlanGroupAutoSelected',
    'nudgePlanCodeAutoSelected',
    'otherPlans',
    'grxId',
    'acqSubSource',
    'ru',
    'ticketId',
    'featureCode',
  ];
  const arrayValues = [
    utmSource,
    utmMedium,
    utmCampaign,
    platform,
    productCode,
    dealCode,
    planCode,
    platform,
    planGroupAutoSelected,
    planCodeAutoSelected,
    nudgePlanGroupAutoSelected,
    nudgePlanCodeAutoSelected,
    otherPlanCodes,
    grxId,
    acqSubSource,
    encodeURIComponent(currentUrl),
    ticketId,
    featureCode,
  ];

  const updatedUrl = doNotAppendUrlIfEmpty(url, arrayKeys, arrayValues);

  return updatedUrl;
};

export const sendDataToGAWithGRX = (passedData = {}) =>
  new Promise((resolve, reject) => {
    const sendBeacon = false;
    const data = passedData;
    data.ProductName = 'TOI';
    const pushGaData = GA_PUSH_DATA_API;

    const typeofPRC = [
      { prc: -1, prctype: '' },
      { prc: 0, prctype: '' },
      { prc: 1, prctype: '' },
      { prc: 2, prctype: '' },
      { prc: 3, prctype: '' },
      { prc: 4, prctype: '' },
      { prc: 5, prctype: '' },
      { prc: 6, prctype: '' },
      { prc: 7, prctype: '' },
      { prc: 8, prctype: '' },
    ];

    const getTypeOfPrc = (key, prcArr) => prcArr.filter(itm => itm.prc === key);
    const prcValue = getPrcCookieValue();
    const ssoid = getCookie('ssoid') || getCookie('ssoId');

    if (ssoid) {
      data.UserLoginStatus = true;
      //  var prcValue = getPrcCookieValue();
      data.UserSubscriptionStatus = getTypeOfPrc(prcValue, typeofPRC)[0]
        ? getTypeOfPrc(prcValue, typeofPRC)[0].prctype
        : '';
      data.featurePermission = data?.accessiblefeatures?.join(',');
    } else {
      data.UserLoginStatus = false;
      data.UserSubscriptionStatus = getTypeOfPrc(prcValue, typeofPRC)[0]
        ? getTypeOfPrc(prcValue, typeofPRC)[0].prctype
        : '';
      data.featurePermission = '';
    }

    //var analyticsData =

    // CD61 Product Name
    // CD63 User Login Status - Hit
    // CD68 User Subscription Status - User
    // CD31 msid
    // CD97 Feature permission
    // CD85 {ET_value/TOI_value/ePaper_value}

    let EPaperCustomDimension = {};
    let logdata = {};
    let updatedData = {};
    let planName = '';
    if (data.accessType === 'TOI_PLUS') {
      planName = 'TOIPlusPAID';
    } else if (data.accessType === 'TIMESPRIME') {
      planName = 'TOIPlus_TimesPrimePaid';
    }

    updatedData = {
      dimension8: '', //category
      dimension9: 'toiplusplans', //Template Type
      dimension10: ssoid && prcValue ? prcValue : -1,
      dimension21: data.UserLoginStatus ? '1' : '0', //Login status
      dimension22: ssoid || '',
      dimension33: planName,
      dimension58: data.source || '',
      dimension31: data.msid || '',

      // dimension96: data.ProductName !== '' ? data.ProductName : '',
      // dimension63: data.UserLoginStatus ? '1' : '0',
      dimension143: data.featurePermission,
      // dimension68:
      // data.UserSubscriptionStatus !== '' ? data.UserSubscriptionStatus : '',
      // dimension85: 'TOI_Plus',
    };

    EPaperCustomDimension = {
      dimension1: 'TOI-ePaper',
      dimension5: data.UserLoginStatus ? '1' : '0',
      dimension10: '',
      dimension12: data.msid,
      dimension26:
        data.UserSubscriptionStatus !== '' ? data.UserSubscriptionStatus : '',
      dimension37: data.featurePermission,
    };
    // if (isEpaper) {
    logdata = JSON.stringify({
      TOI: updatedData,
      epaperUA368321382: EPaperCustomDimension,
      analytics_cdp: data?.analytics_cdp,
      ga4Items: data?.ga4Items,
      objUserData: data?.objUserData,
      grxMappingObj: {},
    });
    // } else {
    // logdata = JSON.stringify(updatedData);
    // }

    const merchantType = 'TOI';
    const grxId = getCookie('_grx');

    const analyticsData = {
      logdata,
      merchantType,
      grxId,
    };

    const timeoutPromise = new Promise(resolve1 => {
      setTimeout(() => {
        resolve1({});
      }, 3000);
    });

    const requestPromise =
      window.navigator && window.navigator.sendBeacon && sendBeacon
        ? navigator.sendBeacon(pushGaData, JSON.stringify(analyticsData))
        : makeRequest.post(pushGaData, analyticsData);

    Promise.race([requestPromise, timeoutPromise])
      .then(() => {
        resolve('Request successful');
      })
      .catch(error => {
        reject(error);
      });
  });
